// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RootNodeName__rootNodeName___r8uZQ {
    font-weight: bold;
    font-size: 20px;
    /* display: flex; */
    /* flex-wrap: wrap; */
}

.RootNodeName__namespacing___EYIXh {
    display: flex;
    width: fit-content;
    margin-right: 15px;
    white-space: pre-line;
}

.RootNodeName__buttons___GiV9G {
    font-size: 12px;
    position: relative;
    top: 1px;
    color: #acacac;
}

.RootNodeName__cancel___GcOwy {
    margin: 5px;
}

.RootNodeName__displayBlock___mWyjF {
    display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootNodeName": `RootNodeName__rootNodeName___r8uZQ`,
	"namespacing": `RootNodeName__namespacing___EYIXh`,
	"buttons": `RootNodeName__buttons___GiV9G`,
	"cancel": `RootNodeName__cancel___GcOwy`,
	"displayBlock": `RootNodeName__displayBlock___mWyjF`
};
module.exports = ___CSS_LOADER_EXPORT___;
